var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40531 19.33C2.0116 19.7129 1.39452 19.7429 0.965449 19.4002C0.452978 18.9908 0.415648 18.2248 0.885889 17.7675L8.87373 10L0.885888 2.23251C0.415648 1.77524 0.452976 1.0092 0.965447 0.599822C1.39452 0.257066 2.01159 0.287135 2.40531 0.669986L12 10L2.40531 19.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.55c38a41.svg";
export { ForwardRef as ReactComponent };